module.exports = __webpack_public_path__ + "media/video-background.d808bf78.mp4";